/**
 * Bridge entre los métodos estáticos de Ant Design y el contexto de React.
 *
 * En antd v5 + React 19, `message.error()` importado de "antd" NO funciona
 * porque crea un root React huérfano. La solución es capturar la instancia
 * real desde `App.useApp()` y exponerla globalmente.
 *
 * Uso:
 * - En App.tsx: llamar `setAntdStatic({ message, modal, notification })`
 * - En cualquier archivo: importar `msg` desde aquí en vez de `message` de "antd"
 */

import type { MessageInstance } from "antd/es/message/interface";
import type { ModalStaticFunctions } from "antd/es/modal/confirm";
import type { NotificationInstance } from "antd/es/notification/interface";

type ModalInstance = Omit<ModalStaticFunctions, "warn">;

let _message: MessageInstance;
let _modal: ModalInstance;
let _notification: NotificationInstance;

export function setAntdStatic(instances: {
  message: MessageInstance;
  modal: ModalInstance;
  notification: NotificationInstance;
}) {
  _message = instances.message;
  _modal = instances.modal;
  _notification = instances.notification;
}

export function getMsg(): MessageInstance {
  return _message;
}

export function getModal(): ModalInstance {
  return _modal;
}

export function getNotification(): NotificationInstance {
  return _notification;
}
